import { render, staticRenderFns } from "./PersonalPropertyReparationForm.vue?vue&type=template&id=6801c009"
import script from "./PersonalPropertyReparationForm.vue?vue&type=script&lang=ts"
export * from "./PersonalPropertyReparationForm.vue?vue&type=script&lang=ts"
import style0 from "./PersonalPropertyReparationForm.vue?vue&type=style&index=0&id=6801c009&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports